/* import __COLOCATED_TEMPLATE__ from './reviewable-histories.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { filterBy } from "@ember/object/computed";
import TEMPLATE from "./reviewable-histories.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  filteredHistories: filterBy("histories", "created", false)
}));